module.exports = __webpack_public_path__ + "img/solution2.a5ad203b.jpg";